/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_New_ImportInputs */

const en_recipe_new_import = /** @type {(inputs: Recipe_New_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New import.`)
};

const de_recipe_new_import = /** @type {(inputs: Recipe_New_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Import.`)
};

/**
* | output |
* | --- |
* | "New import." |
*
* @param {Recipe_New_ImportInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_new_import = /** @type {((inputs?: Recipe_New_ImportInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_New_ImportInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_new_import(inputs)
	return en_recipe_new_import(inputs)
});